const encryptToken = (token) => {
    try {
        const base64 = btoa(token);
        const timestamp = Date.now().toString();
        const encrypted = base64
            .split('')
            .map((char, i) =>
                String.fromCharCode(char.charCodeAt(0) ^ timestamp.charAt(i % timestamp.length).charCodeAt(0))
            )
            .join('');
        return `${encrypted}.${timestamp}`;
    } catch {
        return null;
    }
};

const decryptToken = (encryptedString) => {
    try {
        const [encrypted, timestamp] = encryptedString.split('.');
        const decrypted = encrypted
            .split('')
            .map((char, i) =>
                String.fromCharCode(char.charCodeAt(0) ^ timestamp.charAt(i % timestamp.length).charCodeAt(0))
            )
            .join('');
        return atob(decrypted);
    } catch {
        return null;
    }
};

const setToken = (token) => {
    try {
        const encrypted = encryptToken(token);
        if (encrypted) {
            localStorage.setItem('token', encrypted);
        }
    } catch {
        console.error('Error setting token');
    }
};

const getToken = () => {
    try {
        const storedToken = localStorage.getItem('token');
        return storedToken ? decryptToken(storedToken) : null;
    } catch {
        console.error('Error getting token');
        return null;
    }
};

const clearToken = () => {
    try {
        localStorage.removeItem('token');
    } catch {
        console.error('Error clearing token');
    }
};

const isAuthenticated = () => !!getToken();

export { setToken, getToken, clearToken, isAuthenticated };
